import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ModalDialogResult } from '../../models/modal-dialog-result';
import { CreateFormModalComponent } from './create-form-modal.component';
import { VisitorRegistrationFormType } from '../../models/visitor-registration-form-type';

@Injectable({
    providedIn: 'root'
  })
  export class RegistrationFormModalService {
  
    constructor(private modalService: NgbModal) { 
    }
  
    showCreateNewRegistrationDialog() : Observable<ModalDialogResult<VisitorRegistrationFormType>> {
      const options : NgbModalOptions = { 
        backdrop: 'static' 
      };
      const modalRef = this.modalService.open(CreateFormModalComponent, options);
      return modalRef.componentInstance.onClose;
    }
  }
  